var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"visit-body"},_vm._l((_vm.getVisitsAndCheckUps),function(el,i){return _c('Single',{key:i,attrs:{"id":`${el.type}-${el.data.id}`,"category":el.type,"data":el.data}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }